module.exports = __webpack_public_path__ + "static/media/ie.237169de.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/myaccount/Dashboard/ie.svg
 ** module id = 1329
 ** module chunks = 0
 **/